import React, { useState } from "react";
import {
  GridRenderEditCellParams,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import { TextField } from "@vapor/v3-components";

interface TextFieldGridProps {
  //  cellParam: GridRenderEditCellParams;
  cellParam: GridRenderEditCellParams | GridRenderCellParams;
}

export const TextFieldGrid: React.FC<TextFieldGridProps> = ({ cellParam }) => {
  return (
    <TextField
      label={undefined}
      variant="outlined"
      id={cellParam.id.toString()}
      value={cellParam.value}
      onChange={(e) => {
        cellParam.api.setEditCellValue({
          id: cellParam.id,
          field: cellParam.field,
          value: e.target.value,
        });
      }}
      fullWidth
      size="small"
      InputProps={{
        sx: {
          marginBottom: "1px",
          border: "2px solid #0076ad !important",
          borderRadius: "4px",
          padding: "4px",
          "&:hover": {
            borderColor: "#005f8b !important",
          },
          "&.Mui-focused": {
            borderColor: "#003f5f !important",
          },
        },
      }}
    />
  );
};
